import React from 'react';
import PropTypes from 'prop-types';
import * as ReactRedux from 'react-redux';
import { bindActionCreators } from 'redux';
import { OrganizeTemplateIcon } from 'DesignSystem/Icons';
import { SecondaryButton } from 'DesignSystem/Buttons';
import SelfServeTooltipTourConstants from 'SelfServeTooltipTour/TooltipTourConstants';
import { SelfServeBuilderSidePanelTypes } from 'SelfServeBuilderSidePanel/SelfServeBuilderSidePanelConstants';
import { displayOrganizer } from 'SelfServePostBuilderSidePanel/SelfServePostBuilderSidePanelActions';
import { openPanel } from 'SelfServeBuilderSidePanel/SelfServeBuilderSidePanelActions';

class OrganizeSectionsButton extends React.PureComponent {
  constructor(props) {
    super(props);

    this.reorganizeSections = this.reorganizeSections.bind(this);
  }

  reorganizeSections() {
    window._track('Organize Sections | Preview Modal', 'Template Builder');
    this.props.closeRecipientPreview();
    this.props.displayOrganizer();
    this.props.openPanel(SelfServeBuilderSidePanelTypes.POST_BUILDER);
  }

  render() {
    const {
      activeTooltipIndex,
      isEmptyState,
      isTourDisplayed,
    } = this.props;

    const isAnswerQuestionTooltipDisplayed = isTourDisplayed &&
      (activeTooltipIndex === SelfServeTooltipTourConstants.ANSWER_QUESTION_TOOLTIP_IDX);
    const isOrganizeButtonDisabled = isEmptyState || isAnswerQuestionTooltipDisplayed;

    return (
      <SecondaryButton
        className="recipient-builder-reorganize-button"
        disabled={isOrganizeButtonDisabled}
        onClick={this.reorganizeSections}
        icon={(<OrganizeTemplateIcon />)}
      >
        Organize Sections
      </SecondaryButton>
    );
  }
}

OrganizeSectionsButton.defaultProps = {
  isEmptyState: false,
};

OrganizeSectionsButton.propTypes = {
  activeTooltipIndex: PropTypes.number.isRequired,
  closeRecipientPreview: PropTypes.func.isRequired,
  displayOrganizer: PropTypes.func.isRequired,
  isEmptyState: PropTypes.bool,
  isTourDisplayed: PropTypes.bool.isRequired,
  openPanel: PropTypes.func.isRequired,
};

const mapStateToProps = ({
  TooltipTourReducer,
}) => ({
  activeTooltipIndex: TooltipTourReducer.activeTooltipIndex,
  isTourDisplayed: TooltipTourReducer.isTourDisplayed,
});

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    displayOrganizer,
    openPanel,
  }, dispatch)
);

export default ReactRedux.connect(
  mapStateToProps,
  mapDispatchToProps,
)(OrganizeSectionsButton);



// WEBPACK FOOTER //
// ./src-react/SelfServeRecipientBuilder/components/OrganizeSectionsButton.jsx